import React from 'react'

export const WorkflowCheckIcon = () => (
  <svg
    fill='none'
    height='18'
    viewBox='0 0 18 18'
    width='18'
    xmlns='http://www.w3.org/2000/svg'
  >
    <path
      d='M3 9.25L7.25 13.5L15 4.5'
      stroke='currentColor'
      strokeLinecap='round'
      strokeLinejoin='round'
      strokeWidth='2'
    />
  </svg>
)
